import MuiAvatar, { type AvatarProps as MuiAvatarProps } from '@mui/material/Avatar'
import MuiChip, { type ChipProps as MuiChipProps } from '@mui/material/Chip'

//* AVATAR
export const Avatar = MuiAvatar
export type AvatarProps = MuiAvatarProps

//* CHIP
export const Chip = MuiChip
export type ChipProps = MuiChipProps
